<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.credit-card.multiple-installments-text' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-button-group id="creditCardButton" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    <ap-button-group-item label="{{ 'general.button-group.yes' | apContent }}" value="true"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'general.button-group.no' | apContent }}" value="false"> </ap-button-group-item>
</ap-button-group>
